import React from 'react';
import { Grid } from '@material-ui/core';
import OverallStudentCards from './OverallStudentCards';
import { ReportEntityType } from 'components/ReportsModule/types';
import useSkillProgress from '../hooks/use-skill-progress';
import GET_STUDENT_CURRICULUM_LESSON_REPORT from 'graph/reports/get-student-curriculum-lesson-report';
import { baseVars } from 'graph/apollo-util';
import { useQuery } from '@apollo/client';
import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';
import { PrmStudentCurriculumLessonReportResult } from 'types/schema-generated-types';
import StudentSkillsProgress from './StudentSkillsProgress';

const PrmStudentReport = () => {
  const [
    { setList, selectedProductCurriculumId, curriculumLessonLoading },
    { setSelectedProductCurriculumId }
  ] = useSkillProgress();
  const [{ entityId }] = useReportQueryParams();
  const { data } = useQuery<{
    prmStudentCurriculumLessonReport: PrmStudentCurriculumLessonReportResult;
  }>(GET_STUDENT_CURRICULUM_LESSON_REPORT, baseVars({ studentId: entityId }));

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <OverallStudentCards studentLessonReport={data?.prmStudentCurriculumLessonReport!} />
      </Grid>
      <Grid item xs={12}>
        <StudentSkillsProgress
          studentLessonReport={data?.prmStudentCurriculumLessonReport!}
          setList={setList}
          selected={selectedProductCurriculumId}
          setSelected={setSelectedProductCurriculumId}
          entityType={ReportEntityType.STUDENT}
          loading={curriculumLessonLoading!}
        />
      </Grid>
    </Grid>
  );
};

export default PrmStudentReport;
